/* lua.js generated code 0.3.0 */

require("clover/data/Persistence")
GameGuideData = xClass("GameGuideData")
var instance
GameGuideData.getInstance = function () {
    var self = this
    if (!instance) {
        instance = GameGuideData.new()
    }
    return instance
}
function createProperty(instance, name, typeStr, defaultValue) {
    var funcName = string.upper(string.sub(name, 1, 1)) + string.sub(name, 2)
    if (typeStr === "table") {
        instance["addTo" + funcName] = function (value) {
            (instance[name])[value] = true
        }
        instance["containIn" + funcName] = function (value) {
            return (instance[name])[value]
        }
        instance["removeFrom" + funcName] = function (value) {
            (instance[name])[value] = null
        }
    }
    if (typeStr === "hash") {
        instance["inc" + funcName] = function (value) {
            (instance[name])[value] = ((instance[name])[value] || 0) + 1
        }
        instance["containIn" + funcName] = function (value) {
            return (instance[name])[value] != null
        }
        instance["count" + funcName] = function (value) {
            return (instance[name])[value] || 0
        }
        instance["setCount" + funcName] = function (value, count) {
            (instance[name])[value] = count
        }
        instance["removeFrom" + funcName] = function (value) {
            (instance[name])[value] = null
        }
    }
    instance["set" + funcName] = function (value) {
        if (type(value) === typeStr || value === defaultValue) {
            instance[name] = value
        }
    }
    instance["get" + funcName] = function () {
        if (type(instance[name]) === "table" && typeStr === "hash" || type(instance[name]) === typeStr) {
            return instance[name]
        } else if (type(defaultValue) === "table") {
            // WARN: maybe multi result
            return table.clone(defaultValue)
        } else {
            return defaultValue
        }
    }
    instance["reset" + funcName] = function () {
        if (typeStr === "table" || typeStr === "hash") {
            if (type(defaultValue) === "table") {
                instance[name] = table.clone(defaultValue)
            } else {
                instance[name] = defaultValue
            }
        } else {
            instance[name] = defaultValue
        }
    }
    instance["reset" + funcName]()
}
GameGuideData.prototype.ctor = function () {
    var self = this
    createProperty(self, "guides", "table", table())
    createProperty(self, "guideSeed", "table", table())
    createProperty(self, "processing", "boolean", false)
    createProperty(self, "guideIndex", "number", null)
    createProperty(self, "actionIndex", "number", 0)
    createProperty(self, "guidedIndex", "hash", table())
    createProperty(self, "guideInLevel", "table", table())
    createProperty(self, "skipLevel", "boolean", false)
    createProperty(self, "curLevelGuide", "table", table())
    createProperty(self, "curSuccessGuide", "table", table())
    createProperty(self, "actionReleased", "boolean", true)
    createProperty(self, "actionObjs", "table", table())
    createProperty(self, "guideLayer", "userdata", null)
    createProperty(self, "forceStop", "boolean", false)
    createProperty(self, "numMoves", "number", 0)
    createProperty(self, "levelId", "number", 0)
    createProperty(self, "popups", "number", 0)
    createProperty(self, "gameFlags", "table", table())
    createProperty(self, "scene", "string", "")
    createProperty(self, "gameWaiting", "boolean", false)
    createProperty(self, "succeedGuideIndex", "hash", table())
    createProperty(self, "fishSpawnWave", "number", 0)
    createProperty(self, "levelStage", "number", 0)
    createProperty(self, "gameplayFlags", "table", table())
}
GameGuideData.prototype.setRunningGuide = function (index) {
    var self = this
    self.setGuideIndex(index)
}
GameGuideData.prototype.getRunningGuide = function () {
    var self = this
    if (!self.getGuideIndex()) {
        return null
    }
    return self.getGuides()[self.getGuideIndex()]
}
GameGuideData.prototype.resetRunningGuide = function () {
    var self = this
    self.resetGuideIndex()
}
GameGuideData.prototype.incRunningAction = function () {
    var self = this
    if (!self.getGuideIndex()) {
        return null
    }
    var guide = self.getGuides()[self.getGuideIndex()]
    if (!guide) {
        return null
    }
    self.setActionIndex(self.getActionIndex() + 1)
    return guide.action[self.getActionIndex()]
}
GameGuideData.prototype.getRunningAction = function () {
    var self = this
    if (!self.getGuideIndex()) {
        return null
    }
    var guide = self.getGuides()[self.getGuideIndex()]
    if (!guide) {
        return null
    }
    return guide.action[self.getActionIndex()]
}
GameGuideData.prototype.resetRunningAction = function () {
    var self = this
    self.resetActionIndex()
}
GameGuideData.prototype.getGuideById = function (guideId) {
    var self = this
    return self.getGuides()[guideId]
}
GameGuideData.prototype.getGuideActionById = function (guideId, actionId) {
    var self = this
    var guide = self.getGuideById(guideId)
    if (!guide) {
        return null
    }
    return guide.action[actionId]
}
GameGuideData.prototype.getGuideSeedByLevelId = function (level) {
    var self = this
    return self.getGuideSeed()[level] || 0
}
GameGuideData.prototype.getCurLevelGuideCount = function () {
    let self = this
    let cnt = 0
    let $st19 = self.curLevelGuide || table()
    for (let k in $st19) {
        let v = $st19[k]
        if ($null(v)) continue
        cnt = cnt + 1
    }
    let $st21 = self.doesNotCountGuide || table()
    for (let k in $st21) {
        let v = $st21[k]
        if ($null(v)) continue
        cnt = cnt - 1
    }
    return cnt
}
GameGuideData.prototype.readFromFile = function () {
    var self = this
    var file = Persistence.readFileData(LocalDataFiles.kGameGuideRec) || table()
    for (let i = 1, v = (file.rec || table())[1]; v; i++, v = (file.rec || table())[i]) {
        var [idx, num] = unpack(string.split(tostring(v), ":"))
        var $limit24 = Math.min(tonumber(num) || 0, 9999)
        self.setCountGuidedIndex(tonumber(idx), $limit24)
    }
    for (let i = 1, v = (file.succeed || table())[1]; v; i++, v = (file.succeed || table())[i]) {
        var [idx, num] = unpack(string.split(tostring(v), ":"))
        var $limit31 = Math.min(tonumber(num) || 0, 9999)
        self.setCountSucceedGuideIndex(tonumber(idx), $limit31)
    }
}
GameGuideData.prototype.writeToFile = function () {
    var self = this
    var data = table([1, "rec", table()], [1, "succeed", table()])
    var $st35 = self.getGuidedIndex()
    for (var k in $st35) {
        var v = $st35[k]
        table.insert(data.rec, tostring(k) + ":" + tostring(v))
    }
    var $st37 = self.getSucceedGuideIndex()
    for (var k in $st37) {
        var v = $st37[k]
        table.insert(data.succeed, tostring(k) + ":" + tostring(v))
    }
    Persistence.writeFileData(data, LocalDataFiles.kGameGuideRec)
}
GameGuideData.prototype.transfer = function (oldSrcData, newSrcData) {
    var self = this
    ;[oldSrcData, newSrcData] = [oldSrcData || table(), newSrcData || table()]
    var res = table([1, "rec", table()], [1, "succeed", table()])
    var rec = table()
    for (var i = 1, v = (oldSrcData.rec || table())[1]; v; i++, v = (oldSrcData.rec || table())[i]) {
        var [idx, num] = unpack(string.split(tostring(v), ":"))
        rec[idx] = num || 0
    }
    for (var i = 1, v = (newSrcData.rec || table())[1]; v; i++, v = (newSrcData.rec || table())[i]) {
        var [idx, num] = unpack(string.split(tostring(v), ":"))
        rec[idx] = (rec[idx] || 0) + (num || 0)
    }
    cc.log(table.tostring(rec))
    for (var k in rec) {
        var v = rec[k]
        table.insert(res.rec, tostring(k) + ":" + tostring(v))
    }
    var succeed = table()
    for (var i = 1, v = (oldSrcData.succeed || table())[1]; v; i++, v = (oldSrcData.succeed || table())[i]) {
        var [idx, num] = unpack(string.split(tostring(v), ":"))
        succeed[idx] = num || 0
    }
    for (var i = 1, v = (newSrcData.succeed || table())[1]; v; i++, v = (newSrcData.succeed || table())[i]) {
        var [idx, num] = unpack(string.split(tostring(v), ":"))
        succeed[idx] = (succeed[idx] || 0) + (num || 0)
    }
    cc.log(table.tostring(succeed))
    for (var k in succeed) {
        var v = succeed[k]
        table.insert(res.succeed, tostring(k) + ":" + tostring(v))
    }
    return res
}
let map = table()
GameGuideData.prototype.popStashNode = function (name) {
    let self = this
    if (!name) {
        return null
    }
    let node = map[name]
    map[name] = null
    return node
}
GameGuideData.prototype.pushStashNode = function (name, node) {
    let self = this
    if (node && name) {
        map[name] = node
    }
}
GameGuideData.prototype.getStashNode = function (name) {
    let self = this
    if (!name) {
        return null
    }
    return map[name]
}
module.exports = GameGuideData
